import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

interface CheckoutResponse {
  success: boolean
  partial_checkout?: boolean
  updated_data?: any
  errors?: { message: string }[]
}

export const checkout = async (districtId: number, payload: Object): Promise<CheckoutResponse> => {
  const req = new Request()
  try {
    const response = await req.post(`/ajax/pay/${districtId}`, payload)
    return response.data as CheckoutResponse // Explicitly cast the response data
  } catch (err: any) {
    // AjaxCheckoutController returns {success:false, errors:[CheckoutError…]}
    // with a 5xx on payment failure. Pass the errors array through so callers'
    // .catch(errors => …) handler can render the per-exception toasts (e.g.
    // the "insufficient funds" message). Without this rethrow callers only
    // ever saw the generic "Failed to make payment" Error.
    const apiErrors = err?.response?.data?.errors
    if (Array.isArray(apiErrors)) {
      throw apiErrors
    }
    throw new Error('Failed to make payment: ' + err)
  }
}
